module.exports = __webpack_public_path__ + "img/bannerOrange.509e50b0.jpg";